import React, { useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { LINKS } from "constants/options";
import profileIcon from "assets/images/profile.svg";
import UserModel from "models/userModel";
import Button from "../Button";
import { Container, NavBar, Nav, NavLink, Content } from "./styles";

export default function Layout() {
	const navigate = useNavigate();
	const { logout, userData } = useContext(UserModel.Context);
	return (
		<Container>
			<NavBar>
				<Nav>
					{LINKS[process.env.REACT_APP_NAME].map(({ name, path }) => (
						<NavLink key={name} onClick={() => navigate(path)}>{name}</NavLink>
					))}
				</Nav>
				<Nav>
					<div className="d-flex align-items-center">
						<div>{userData?.userPrincipalName || ''}</div>
						<Button variant="link" onClick={logout}>
							Log out
							<img src={profileIcon} alt="logout" />
						</Button>
					</div>
				</Nav>
			</NavBar>
			<Content>
				<Outlet />
			</Content>
		</Container>
	)
}
